"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _useTransitionIn = _interopRequireDefault(require("../../customHooks/useTransitionIn"));

var _Storyblok = _interopRequireDefault(require("../../../../utils/Storyblok"));

var _Blok = _interopRequireDefault(require("../../../StoryBlokPage/components/Blok/Blok"));

var _customProps = require("../../../../utils/customProps");

var MuiFade = function MuiFade(_ref) {
  var rootClass = _ref.rootClass,
      content = _ref.content,
      fadeIn = _ref.fadeIn,
      enter = _ref.enter,
      exit = _ref.exit;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass);

  var transTime = (0, _useTransitionIn.default)(fadeIn);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/_react.default.createElement(_core.Fade, {
    in: transTime,
    timeout: {
      enter: +enter,
      exit: +exit
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, content.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_Blok.default, (0, _extends2.default)({}, item, {
      key: index
    }));
  }))));
};

var _default = MuiFade;
exports.default = _default;
MuiFade.propTypes = {
  /**
   * stroyblok multiselect of css classes
   * Mui Override or extend the styles applied to the component.
   */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * mui props: number
   * Number of milliseconds for component to transition in.
   */
  fadeIn: _propTypes.default.string,

  /**
   * mui props: number
   * Number of milliseconds for component to effect on screen.
   */
  enter: _propTypes.default.string,

  /**
   * mui props: number
   * Number of milliseconds for component to effect off screen.
   */
  exit: _propTypes.default.string,

  /**
   * Content passed to render
   * components: Blok
   */
  content: function content(props, propName, componentName) {
    return (0, _customProps.validComponentsRequired)(props, propName, componentName, ['Blok'], 1);
  }
};
MuiFade.defaultProps = {
  fadeIn: 300,
  enter: 1500,
  exit: 1500,
  rootClass: [],
  content: []
};